<template>
  <div class="container">
    <tracker-datatable />
  </div>
</template>

<script>
import TrackerDatatable from "./tracker_datatable/Index.vue";

export default {
  name: "CentralDispatchTrackerIndex",
  components: { TrackerDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
